import { Router } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';


@Component({
  selector: 'app-publication-preview-wrapper',
  templateUrl: './publication-preview-wrapper.component.html',
  styleUrls: ['./publication-preview-wrapper.component.scss']
})
export class PublicationPreviewWrapperComponent implements OnInit {

  @Input() public url;
  @Input() public isAdvertisement;
  @Input() public materialAd;
  fromModule: any;
  showPublication = false;

  constructor(private _router: Router) {

    const navigation = this._router.getCurrentNavigation();

    if (navigation && navigation.extractedUrl.queryParams) {
      this.url = navigation.extractedUrl.queryParams.url;
      this.isAdvertisement = navigation.extractedUrl.queryParams.isAdvertise == "false" ? false : true;
      this.fromModule = navigation.extractedUrl.queryParams.fromModule;
    }
  }

  ngOnInit() {
    this.showPublication = !this.isAdvertisement;
  }

  change(value) {
    this.showPublication = value;
  }

}
